import { Type, either, optional, verify } from "specified";
const urlString = Type.string;
const ContextSchema = Type.interface({
  "@vocab": urlString,
  eyewear: urlString
});
const CategoryRelatedLinkSchema = Type.interface({
  "@type": Type.literalValue("https://purl.archive.org/purl/eyewear/CategoryRelatedLinks"),
  "eyewear:categoryRelatedLinkName": either(Type.string, Type.array(Type.string)),
  "eyewear:categoryRelatedLinkOrder": either(Type.string, Type.array(Type.string)),
  "eyewear:categoryRelatedLinkUrl": either(Type.string, Type.array(Type.string))
});
const ItemSchema = Type.interface({
  "@type": Type.literalValue("CollectionPage"),
  "@id": urlString,
  name: Type.string,
  description: Type.string,
  headline: optional(Type.string),
  text: optional(Type.string),
  abstract: optional(Type.string),
  image: optional(Type.string),
  datePublished: optional(Type.string),
  mainEntityOfPage: urlString,
  "@context": ContextSchema,
  url: urlString,
  relatedLink: Type.array(urlString),
  "eyewear:categoryRelatedLinks": Type.array(CategoryRelatedLinkSchema)
});
const DataSchema = Type.array(ItemSchema);
const validateSchema = (data) => verify(DataSchema, data);
export {
  validateSchema
};
//# sourceMappingURL=schema-validator.js.map
